"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = ["1 SERVER", "2-5 SERVERS", "6-10 SERVERS", "11-50 SERVERS", "51-100 SERVERS", "> 100 SERVERS"];
exports.default = _default;
//# sourceMappingURL=number_of_servers_project.js.map